import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const AddPlatform = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.AddPlatform,
        method: RequestType.POST,
        data,
    });

const DeletePlatform = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeletePlatform + '?PlatformId=' + data.PlatformId,
        method: RequestType.DELETE,
    });

const UpdatePlatform = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdatePlatform,
        method: RequestType.PUT,
        data,
    });

const MasterDataCommand = {
    AddPlatform,
    DeletePlatform,
    UpdatePlatform,
};

export default MasterDataCommand;
